import { LONG_TRANSLATION_KEY, SHORT_TRANSLATION_KEY } from './constants';

export const getTranslationKeyForSameDayShipping = ( shortVersion = LONG_TRANSLATION_KEY) =>
    shortVersion === SHORT_TRANSLATION_KEY
        ? 'shipping-time-same-day-shipping-short'
        : 'shipping-time-same-day-shipping';
